<template>
  <b-container fluid>
    <b-row>
      <b-col lg="12" sm="12">
        <iq-card>
          <template v-slot:body>
            <b-overlay :show="loader">
                <b-row>
                    <b-col xl="12" lg="12" sm="12">
                        <ValidationObserver ref="form"  v-slot="{ handleSubmit, reset }">
                            <b-form @submit.prevent="handleSubmit(getEmployeeList)" @reset.prevent="reset">
                                <b-row class="mt-2">
                                    <b-col>
                                        <ValidationProvider name="Year" vid="year_id" rules="required|min_value:1">
                                            <b-form-group
                                                class="row"
                                                label-cols-sm="5"
                                                label-for="year_id"
                                                slot-scope="{ valid, errors }"
                                            >
                                            <template v-slot:label>
                                                {{$t('globalTrans.year')}} <span class="text-danger">*</span>
                                            </template>
                                            <b-form-select
                                            plain
                                            v-model="exam.year"
                                            :options="yearList"
                                            :disabled="isReadonly"
                                            id="year_id"
                                            :state="errors[0] ? false : (valid ? true : null)"
                                            >
                                            <template v-slot:first>
                                                <b-form-select-option :value="0" disabled>{{$t('globalTrans.select')}}</b-form-select-option>
                                            </template>
                                            </b-form-select>
                                                <div class="invalid-feedback">
                                                {{ errors[0] }}
                                                </div>
                                            </b-form-group>
                                        </ValidationProvider>
                                    </b-col>
                                    <b-col lg="6"  sm="12">
                                        <ValidationProvider name="Organization" vid="org_id" rules="required|min_value:1">
                                            <b-form-group
                                                class="row"
                                                label-cols-sm="5"
                                                label-for="org_id"
                                                slot-scope="{ valid, errors }"
                                            >
                                            <template v-slot:label>
                                                {{$t('globalTrans.organization')}} <span class="text-danger">*</span>
                                            </template>
                                            <b-form-select
                                            plain
                                            v-model="exam.org_id"
                                            :options="orgList"
                                            :disabled="isReadonly"
                                            id="org_id"
                                            :state="errors[0] ? false : (valid ? true : null)"
                                            >
                                            <template v-slot:first>
                                                <b-form-select-option :value="0" disabled>{{$t('globalTrans.select')}}</b-form-select-option>
                                            </template>
                                            </b-form-select>
                                            <div class="invalid-feedback">
                                            {{ errors[0] }}
                                            </div>
                                            </b-form-group>
                                        </ValidationProvider>
                                    </b-col>
                                    <b-col lg="6" sm="12">
                                        <ValidationProvider name="Institute Type" vid="institute_type_id" rules="required|min_value:1">
                                                <b-form-group
                                                    class="row"
                                                    label-cols-sm="5"
                                                    label-for="institute_type "
                                                    slot-scope="{ valid, errors }"
                                                    >
                                                    <template v-slot:label>
                                                    {{$t('ds_institute_management.institute_type')}}  <span class="text-danger">*</span>
                                                    </template>
                                                    <b-form-select
                                                    plain
                                                    v-model="exam.office_type_id"
                                                    id="institute_type_id"
                                                    :options="officeTypeList"
                                                    :disabled="isReadonly"
                                                    :state="errors[0] ? false : (valid ? true : null)"
                                                    >
                                                    <template v-slot:first>
                                                        <b-form-select-option :value="0" disabled>{{$t('globalTrans.select')}}</b-form-select-option>
                                                    </template>
                                                    </b-form-select>
                                                    <div class="invalid-feedback">
                                                    {{ errors[0] }}
                                                    </div>
                                                </b-form-group>
                                        </ValidationProvider>
                                    </b-col>
                                    <b-col lg="6" sm="12">
                                        <ValidationProvider name="Institute Name" vid="institute_name" rules="required|min_value:1">
                                            <b-form-group
                                                class="row"
                                                label-cols-sm="5"
                                                label-for="institute_name "
                                                slot-scope="{ valid, errors }"
                                                >
                                                <template v-slot:label>
                                                {{$t('ds_institute_management.institute_name')}} <span class="text-danger">*</span>
                                                </template>
                                                <b-form-select
                                                plain
                                                v-model="exam.office_id"
                                                id="institute_name"
                                                :options="officeList"
                                                :disabled="isReadonly"
                                                :state="errors[0] ? false : (valid ? true : null)"
                                                >
                                                <template v-slot:first>
                                                    <b-form-select-option :value="0" disabled>{{$t('globalTrans.select')}}</b-form-select-option>
                                                </template>
                                                </b-form-select>
                                                <div class="invalid-feedback">
                                                {{ errors[0] }}
                                                </div>
                                            </b-form-group>
                                        </ValidationProvider>
                                    </b-col>
                                    <b-col lg="6"  sm="12">
                                        <ValidationProvider name="Employee Type" vid="manpower_type" rules="required|min_value:1">
                                            <b-form-group
                                                class="row"
                                                label-cols-sm="5"
                                                label-for="manpower_type"
                                                slot-scope="{ valid, errors }"
                                            >
                                            <template v-slot:label>
                                                {{$t('employee_management.manpower_type')}} <span class="text-danger">*</span>
                                                </template>
                                                <b-form-select
                                                plain
                                                v-model="exam.manpower_type"
                                                :options="empType"
                                                :disabled="isReadonly"
                                                id="manpower_type"
                                                :state="errors[0] ? false : (valid ? true : null)"
                                                >
                                                <template v-slot:first>
                                                    <b-form-select-option :value="0" disabled>{{$t('globalTrans.select')}}</b-form-select-option>
                                                </template>
                                                </b-form-select>
                                                <div class="invalid-feedback">
                                                {{ errors[0] }}
                                                </div>
                                            </b-form-group>
                                        </ValidationProvider>
                                    </b-col>
                                    <b-col lg="6" sm="12">
                                        <div class="text-right">
                                            <b-button type="submit" variant="primary">{{ $t('globalTrans.search')}}</b-button>
                                        </div>
                                    </b-col>
                                </b-row>
                            </b-form>
                        </ValidationObserver>
                        <hr>
                        <ValidationObserver ref="form1"  v-slot="{ handleSubmit, reset }">
                            <b-form @submit.prevent="handleSubmit(storeUpdate)" @reset.prevent="reset">
                                <b-row>
                                    <b-col xl="12" lg="12" sm="12">
                                        <b-table-simple bordered>
                                            <thead class="text-white bg-primary">
                                                <tr class="bg-primary">
                                                    <th scope="col">{{ $t('globalTrans.sl_no') }}</th>
                                                    <th scope="col">{{ $t('employee_management.manpower_type') }}</th>
                                                    <th scope="col">{{ $t('ds_institute_management.name') }}</th>
                                                    <th scope="col">{{ $t('ds_institute_management.designation') }}</th>
                                                    <th scope="col" class="text-center">{{ $t('globalTrans.action') }}</th>
                                                </tr>
                                            </thead>
                                            <b-tbody v-if="tmpDataStatus">
                                                <b-tr v-for="(item, index) in exam.details" :key="index">
                                                    <b-td>
                                                        {{ $n(index + 1) }}
                                                    </b-td>
                                                    <b-td v-if="item.manpower_type == 1">
                                                        {{ $t('ds_institute_management.teacher') }}
                                                    </b-td>
                                                    <b-td v-else>
                                                        {{ $t('ds_institute_management.stuff') }}
                                                    </b-td>
                                                    <b-td>
                                                        {{ (currentLocale == 'bn') ? item.name_bn : item.name }}
                                                    </b-td>
                                                    <b-td>
                                                        {{ (currentLocale == 'bn') ? item.designation_bn : item.designation }}
                                                    </b-td>
                                                    <b-td class="d-flex justify-content-center align-items-center">
                                                        <input type="checkbox" :id="'is_checked-' + index" v-model="item.is_checked"/>
                                                        <b-form-file
                                                            v-if="!item.is_checked"
                                                            :id="'attachment-' + index"
                                                            v-on:change="onFileChange($event, index)"
                                                            class="ml-3"
                                                            style="width: 70%;"
                                                            variant="primary"
                                                            placeholder="Upload Absent File"
                                                        >
                                                        </b-form-file>
                                                    </b-td>
                                                </b-tr>
                                                <b-tr v-if="noData">
                                                    <td colspan="5" class="text-center">
                                                        <span class="text-black">{{ $t('globalTrans.noDataFound') }}</span>
                                                    </td>
                                                </b-tr>
                                            </b-tbody>
                                        </b-table-simple>
                                    </b-col>
                                        <b-col lg="6" sm="12">
                                            <ValidationProvider name="Date" vid="attendance_date" rules="required">
                                                <b-form-group
                                                    class="row"
                                                    label-cols-sm="5"
                                                    label-for="attendance_date"
                                                    slot-scope="{ valid, errors }"
                                                >
                                                <template v-slot:label>
                                                    {{$t('educational_management.date')}} <span class="text-danger">*</span>
                                                    </template>
                                                    <flat-pickr class="form-control"
                                                    v-model="exam.attendance_date"
                                                    id="attendance_date"
                                                    :placeholder="$t('globalTrans.select_date')"
                                                    :state="errors[0] ? false : (valid ? true : null)"
                                                    ></flat-pickr>
                                                    <div class="invalid-feedback">
                                                    {{ errors[0] }}
                                                    </div>
                                                </b-form-group>
                                            </ValidationProvider>
                                    </b-col>
                                </b-row>
                                <div class="row">
                                    <div class="col-sm-3"></div>
                                    <div class="col text-right">
                                        <b-button type="submit" :disabled='isDisabled' variant="primary" class="mr-2">{{ saveBtnName }}</b-button>
                                            &nbsp;
                                        <b-button variant="danger" class="mr-1" @click="$bvModal.hide('modal-4')">{{ $t('globalTrans.cancel') }}</b-button>
                                    </div>
                                </div>
                            </b-form>
                        </ValidationObserver>
                    </b-col>
                </b-row>
            </b-overlay>
          </template>
        </iq-card>
      </b-col>
    </b-row>
  </b-container>
</template>
<script>
import { mapGetters } from 'vuex'
import { core } from '../../../../../config/pluginInit'
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import RestApi, { disabilitySchoolServiceBaseUrl } from '../../../../../config/api_config'
import { getListTeacherStuff, teacherStuffAttendance, teacherStuffAttendanceUpdate } from '../../api/routes'
import flatpickr from 'flatpickr'

export default {
    name: 'FormLayout',
    props: ['id'],
    components: {
        ValidationObserver,
        ValidationProvider
    },
    created () {
        this.exam.org_id = this.$store.state.dataFilters.orgId
        this.exam.office_type_id = this.$store.state.dataFilters.officeTypeId
        this.exam.office_id = this.$store.state.dataFilters.officeId
        if (this.id) {
            this.noData = true
            const tmp = this.getExamInfoData()
            this.exam = tmp
            this.getEmployeeList()
        }
    },
    mounted () {
        core.index()
        flatpickr('.date-picker', {})
    },
    data () {
        return {
            saveBtnName: this.id ? this.$t('globalTrans.update') : this.$t('globalTrans.save'),
            loader: false,
            exam: {
                year: 0,
                org_id: 0,
                office_type_id: 0,
                office_id: 0,
                manpower_type: 0,
                attendance_date: '',
                attachment: [],
                details: []
            },
            officeTypeList: [],
            officeList: [],
            classList: [],
            readonly: false,
            isDisabled: true,
            isReadonly: false,
            tmpDataStatus: 0,
            noData: true
        }
    },
    computed: {
        yearList: function () {
            return this.$store.state.DisabilitySchoolService.commonObj.yearList.map(item => {
                if (this.$i18n.locale === 'bn') {
                    return { value: item, text: this.$n(item, { useGrouping: false }) }
                } else {
                    return item
                }
            })
        },
        orgList: function () {
            const obj = this.$store.state.commonObj.organizationProfileList.filter(item => item.status === 0)
            return obj.map((obj, key) => {
                if (this.$i18n.locale === 'bn') {
                    return { value: obj.value, text: obj.text_bn }
                } else {
                    return { value: obj.value, text: obj.text_en }
                }
            })
        },
        empType: function () {
            const list = [
                { value: 1, text: this.$i18n.locale === 'en' ? 'Teacher' : 'শিক্ষক' },
                { value: 2, text: this.$i18n.locale === 'en' ? 'Staff' : 'স্টাফ' }
            ]
            return list
        },
        currentLocale () {
            return this.$i18n.locale
        },
        ...mapGetters({
            childCommonObj: 'ChildService/commonObj'
        })
    },
    watch: {
        'exam.org_id': function (newVal) {
            this.officeTypeList = this.getOfficeTypeList(newVal)
        },
        'exam.office_type_id': function (newVal) {
            this.officeList = this.getOfficeList(newVal)
        },
        'exam.office_id': function (newVal) {
            this.classList = this.getClassList(newVal)
        }
    },
    methods: {
        onFileChange (e, index) {
        const input = e.target
            if (input.files && input.files[0]) {
                const reader = new FileReader()
                reader.onload = (e) => {
                    this.exam.details[index].attachment = e.target.result
                }
                reader.readAsDataURL(input.files[0])
            } else {
                this.exam.details[index].attachment = ''
            }
        },
        getExamInfoData () {
            const tmpData = this.$store.state.list.find(item => item.id === this.id)
            return JSON.parse(JSON.stringify(tmpData))
        },
        async storeUpdate () {
            this.loader = true
            this.$store.dispatch('mutateCommonProperties', { loading: true })
            let result = null
            const config = {
                headers: { 'content-type': 'multipart/form-data' }
            }
            var formData = new FormData()
            Object.keys(this.exam).map(key => {
                if (key === 'attachment') {
                    // formData.append('attachment', this.attachment)
                } else {
                    formData.append(key, this.exam[key])
                }
            })
            const loadinState = { loading: false, listReload: true }
            if (this.id) {
                result = await RestApi.putData(disabilitySchoolServiceBaseUrl, `${teacherStuffAttendanceUpdate}/${this.id}`, this.exam, config, formData)
            } else {
                result = await RestApi.postData(disabilitySchoolServiceBaseUrl, teacherStuffAttendance, this.exam, config, formData)
            }
            this.$store.dispatch('mutateCommonProperties', loadinState)
            if (result.warning) {
                this.loader = false
                this.$store.dispatch('mutateCommonProperties', { hasDropdownLoaded: false })
                this.$toast.error({
                    title: this.$t('globalTrans.success'),
                    message: this.$t(result.message),
                    color: '#fff000'
                })
            }

            if (result.success) {
                this.loader = false
                this.$store.dispatch('mutateCommonProperties', { hasDropdownLoaded: false })
                this.$toast.success({
                    title: this.$t('globalTrans.success'),
                    message: this.id ? this.$t(result.message) : this.$t(result.message),
                    color: '#D6E09B'
                })
                this.$bvModal.hide('modal-4')
            } else {
                this.loader = false
                this.$refs.form.setErrors(result.errors)
            }
        },
        getOfficeTypeList () {
            const objectData = this.$store.state.commonObj.officeTypeList.filter(item => item.status === 0 && item.org_id === this.exam.org_id)
            return objectData.map((obj, key) => {
                if (this.$i18n.locale === 'bn') {
                    return { value: obj.value, text: obj.text_bn }
                } else {
                    return { value: obj.value, text: obj.text_en }
                }
            })
        },
        getOfficeList () {
            const objectData = this.$store.state.commonObj.officeList.filter(item => item.status === 0 && item.office_type_id === this.exam.office_type_id)
            return objectData.map((obj, key) => {
                if (this.$i18n.locale === 'bn') {
                    return { value: obj.value, text: obj.text_bn }
                } else {
                    return { value: obj.value, text: obj.text_en }
                }
            })
        },
        getClassList () {
            const objectData = this.$store.state.DisabilitySchoolService.commonObj.classList.filter(item => item.status === 1)
            return objectData.map((obj) => {
                if (this.$i18n.locale === 'bn') {
                    return { value: obj.value, text: obj.text_bn }
                } else {
                    return { value: obj.value, text: obj.text_en }
                }
            })
        },
        getRelationData (data) {
            return data.map(item => {
                if (this.$i18n.locale === 'bn') {
                    return { value: item.employee_id, text: item.name_bn }
                } else {
                    return { value: item.employee_id, text: item.name }
                }
            })
        },
        async getEmployeeList () {
            this.loader = true
            const params = Object.assign({}, { year: this.exam.year, org_id: this.exam.org_id, office_type_id: this.exam.office_type_id, office_id: this.exam.office_id, manpower_type: this.exam.manpower_type })
            await RestApi.getData(disabilitySchoolServiceBaseUrl, getListTeacherStuff, params).then(response => {
                if (response.success) {
                    const resData = response.data
                    if (resData) {
                        if (this.id) {
                            this.isReadonly = true
                            this.exam.details = resData.map(item => {
                                const resItem = this.exam.details.find(res => res.employee_id === item.employee_id)
                                if (resItem) {
                                    item.is_checked = true
                                    return item
                                } else {
                                    item.is_checked = false
                                    return item
                                }
                            })
                        } else {
                            this.exam.details = resData.map(item => {
                                item.is_checked = true
                                return item
                            })
                        }
                    }
                    if (this.exam.details.length > 0) {
                        this.isDisabled = false
                        this.noData = false
                    }
                }
                this.tmpDataStatus = 1
                this.loader = false
            })
        }
    }
}
</script>
